import {
  IonApp,
  setupIonicReact
} from '@ionic/react';

import { Provider } from 'react-redux';
import { StatusBar } from '@capacitor/status-bar';
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';


/* Theme variables */
import './theme/variables.css';
import './index.scss'
import { AppContextProvider } from './services/app-context.service';
import AuthGuard from './components/AuthGuard';
import { store } from './stores/app.store';
import { useEffect } from 'react';

setupIonicReact();


const App: React.FC = () => {

  useEffect(() => {
    StatusBar.setOverlaysWebView({ overlay: false });
    // StatusBar.setBackgroundColor({ color: '#ffffff' });
    // StatusBar.setStyle({ style: Style.Light });
  }, []);


  return (
    <IonApp>
      <Provider store={store}>
        <AppContextProvider>
          <AuthGuard />
        </AppContextProvider>
      </Provider>
    </IonApp>
  )
};

export default App;
